
<cv-loader [size]="'large'" [overlay]="true" *ngIf="submittingCompany"></cv-loader>

<div class="content position-relative pt-4 pr-4 pb-3 my-3 mx-auto" style="width:500px; padding-left:32px">
    <div class="lato-bold font-size-18 border-bottom mb-3" style="padding-bottom:8px" cvLocalizedText langSection="First_Phase_Integration" langKey="Create_Company_Account">Create Company Account</div>

    <!-- Radio Buttons -->
    <div class="font-size-12 mb-2" cvLocalizedText langSection="First_Phase_Integration" langKey="Integration_Type">Integration Type</div>
    <div class="bodyRow ml-4">
        <div>
            <input type="radio" [(ngModel)]="fpis.save.Type" [value]="'pm'" (ngModelChange)="clearSelections();">
            <label cvLocalizedPlaceholder [langSection]="'First_Phase_Integration'" [langKey]="'Performance_Management'">Performance Management</label>
        </div>
        <div>
            <input type="radio" [(ngModel)]="fpis.save.Type" [value]="'dash'" (ngModelChange)="clearSelections();">
            <label cvLocalizedPlaceholder [langSection]="'First_Phase_Integration'" [langKey]="'Dashboard'">Dashboard</label>
        </div>
    </div>

    <div class="font-size-12 mb-2" cvLocalizedText langSection="First_Phase_Integration" langKey="Company_Name">Company Name</div>
    <div class="mb-3"><input class="form-control" style="width:212px" type="text" [(ngModel)]="fpis.save.CompanyName" (ngModelChange)="autoSuggestSubdomain()" /></div>

    <div class="font-size-12 mb-2" cvLocalizedText langSection="First_Phase_Integration" langKey="Subdomain_Name">Subdomain Name</div>
    <div class="d-flex align-items-center">
        <input class="form-control mr-1" [ngClass]="{ 'is-valid': subdomainAvailable && subdomainValid && !subdomainPristine && !validatingSubdomain,
                'is-invalid': (!subdomainAvailable || !subdomainValid || fpis.save.SubdomainName.length == 0) && !subdomainPristine && !validatingSubdomain }"
               style="width:212px" type="text" [(ngModel)]="fpis.save.SubdomainName" (ngModelChangeDebounced)="subdomainPristine = false; validateSubdomain()"
               [ngModelChangeDebounceTime]="400" [disabled]="validatingSubdomain" />
        <span class="font-size-12" *ngIf="subDomainBase != null">{{"." + subDomainBase}}</span>
        <span class="font-size-12 color-redRyder" *ngIf="subDomainBase == null" cvLocalizedText langSection="First_Phase_Integration" langKey="Subdomain_Base_Error">invalid subdomain base</span>
    </div>
    <div class="mb-3">
        <span class="font-size-12 color-redRyder" *ngIf="!subdomainValid && !subdomainPristine && !validatingSubdomain"
              cvLocalizedText langSection="First_Phase_Integration" langKey="Subdomain_Error"></span>
        <span class="font-size-12 color-redRyder" *ngIf="!subdomainAvailable && subdomainValid && !subdomainPristine && !validatingSubdomain"
              cvLocalizedText langSection="First_Phase_Integration" langKey="Subdomain_Availability_Error"></span>
    </div>

    <div class="font-size-12 mb-2" cvLocalizedText langSection="First_Phase_Integration" langKey="Time_Zone_Source">Time Zone Source</div>
    <select class="form-control mb-3" style="width:212px" [(ngModel)]="fpis.save.TimeZoneSource" [disabled]="true">
        <option label="UTC" value="UTC" selected="selected">UTC</option>
    </select>

    <div *ngIf="fpis.save.Type != 'dash'">
        <div class="font-size-12 mb-2" cvLocalizedText langSection="First_Phase_Integration" langKey="Time_Zone_Default">Time Zone Default</div>
        <select class="form-control mb-3" [ngClass]="{ 'is-invalid': validationTzFailed }" style="width:212px" [(ngModel)]="fpis.save.TimeZoneDefault" (ngModelChange)="validationTzFailed = false">
            <option *ngFor="let entry of timeZones | keyvalue: originalOrder" [label]="entry.value" [ngValue]="entry.key"></option>
        </select>

        <div class="font-size-12 mb-2" cvLocalizedText langSection="First_Phase_Integration" langKey="Extra_Time_Zones">Extra Time Zones</div>
        <select class="form-control mb-3" style="width:212px" [(ngModel)]="fpis.save.ExtraTimeZone1">
            <option *ngFor="let entry of timeZones | keyvalue: originalOrder" [label]="entry.value" [ngValue]="entry.key"></option>
        </select>
        <select class="form-control mb-3" style="width:212px" [(ngModel)]="fpis.save.ExtraTimeZone2">
            <option *ngFor="let entry of timeZones | keyvalue: originalOrder" [label]="entry.value" [ngValue]="entry.key"></option>
        </select>
        <select class="form-control mb-3" style="width:212px" [(ngModel)]="fpis.save.ExtraTimeZone3">
            <option *ngFor="let entry of timeZones | keyvalue: originalOrder" [label]="entry.value" [ngValue]="entry.key"></option>
        </select>
    </div>

    <div *ngIf="fpis.save.Type == 'dash'">
        <div class="font-size-12 mb-2" cvLocalizedText langSection="First_Phase_Integration" langKey="Time_Zone_Default">Time Zone Default</div>
        <select class="form-control mb-3" [ngClass]="{ 'is-invalid': validationTzFailed }" style="width:212px" [(ngModel)]="fpis.save.TimeZoneDefault" (ngModelChange)="validationTzFailed = false">
            <option *ngFor="let entry of timeZones | keyvalue: originalOrder" [label]="entry.key" [ngValue]="entry.value"></option>
        </select>
    </div>

    <div class="font-size-12 mb-2" cvLocalizedText langSection="First_Phase_Integration" langKey="Access_Key_Id">Access Key ID</div>
    <input class="form-control mb-3" type="text" [ngClass]="{ 'is-invalid': validationFailed }" style="width:212px" [(ngModel)]="fpis.save.CredentialPrimary" (ngModelChange)="validationFailed = false" />

    <div class="font-size-12 mb-2" cvLocalizedText langSection="First_Phase_Integration" langKey="Access_Key_Secret">Access Key Secret</div>
    <input class="form-control" type="text" [ngClass]="{ 'is-invalid': validationFailed }" style="width:212px" [(ngModel)]="fpis.save.CredentialSecret" (ngModelChange)="validationFailed = false" />
    <div style="height:24px">
        <span class="font-size-12 color-redRyder" *ngIf="validationFailed" cvLocalizedText langSection="First_Phase_Integration" langKey="Validation_Error"></span>
    </div>

    <div class="font-size-12 mb-2" cvLocalizedText langSection="First_Phase_Integration" langKey="Region_Domain">Region Domain</div>
    <select class="form-control mb-3" style="width:100px" [(ngModel)]="fpis.save.Domain">
        <option *ngFor="let region of regionKeys" [label]="region" [ngValue]="region"></option>
    </select>

    <div>
        <input type="checkbox" [(ngModel)]="fpis.save.UseCaseSensitiveRawData" />
        <label cvLocalizedText langSection="First_Phase_Integration" langKey="Case_Sensitive_Raw">Case-sensitive raw data</label>
    </div>

    <div class="d-flex justify-content-end pt-3 border-top mt-3">
        <button type="button" class="btn btn-primary mr-2" (click)="createCompany()" [disabled]="submittingCompany || subDomainBase == null" cvLocalizedText langSection="First_Phase_Integration" langKey="Submit_Button">Submit</button>
    </div>
</div>

